<template>
    <div class="row m-0 p-0">
      <div :class="isMobile ? 'col-12 text-center' : 'col-auto p-0'">
        <div class="d-inline-block page-title-box-spacing">
          <div class="d-flex align-items-center topbar-right-spacing name-header" :class="isMobile && 'm-0'">
            <div>Անժամկետ տենդերներ</div>
          </div>
        </div>
      </div>
      <template v-if="isMobile">
        <div class="col-12 text-center p-0">
          <select v-model="selectedPagePath" @change="selectPage" class="contract-managment-select">
            <option value="/timeless-tenders/buy/list">
              Անժամկետ տենդերներ
            </option>
            <option value="/timeless-tenders/buy/orders">
              Պատվերներ
            </option>
            <option value="/timeless-tenders/buy/admin">
              Ադմին
            </option>
          </select>
        </div>
      </template>
      <template v-else>
        <div class="col-auto">
          <div class="d-inline-block">
            <ul class="nav nav-tabs align-items-end suggestions-tab" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="nav-link" :class="selectedPage === 'list' && 'active'" id="home-tab" data-toggle="tab" href="#list" @click.prevent="$router.push('/timeless-tenders/buy/list')" role="tab" aria-controls="home" aria-selected="true">
                  Անժամկետ տենդերներ
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" :class="selectedPage === 'orders' && 'active'" id="contact-tab" data-toggle="tab" href="#list" @click.prevent="$router.push('/timeless-tenders/buy/orders')" role="tab" aria-controls="contact" aria-selected="false">
                  Պատվերներ
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" :class="selectedPage === 'admin' && 'active'" id="home-tab" data-toggle="tab" href="#admin" @click.prevent="$router.push('/timeless-tenders/buy/admin')" role="tab" aria-controls="home" aria-selected="true">
                  Ադմին
                </a>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </div>
</template>
<script>
import isMobile from '@/mixins/isMobileView'

export default {
  mixins: [isMobile],
  data() {
    return {
      dateNow: new Date(),
      backendUrl: process.env.VUE_APP_URL,
      selectedPagePath: '',
      selectedPage: '',
    }
  },
  computed: {
    currentPlan() {
      return this.$store.getters['procurement/currentPlan']
    },
    locale() {
      return this.$store.getters['user/locale']
    },
    me() {
      return this.$store.getters['user/me']
    }
  },
  mounted() {
    this.selectedPagePath = this.$route.path;
    this.selectedPage = this.$route.path.split('/')[3];
    this.$client.get('manager/timeless-tenders').then(({data}) => {
      this.tenders = data.data;
    })
  },
  methods: {
    selectPage(event){
      this.$router.push(event.target.value)
    },
  },
}
</script>

